import router from "@/router"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"
import vuexStore from "@/store"
import { LoadState, RPKundendatenRequest, RemoteResult } from "mangdto"

export default class KundendatenReservierungLogic extends BaseLogic {
  insertWorking: boolean = false
  insertError: boolean = false

  bestellungCompleted: boolean = false
  formValid: boolean = true
  kundeNachname?: string = null
  kundeVorname?: string = null
  kundeEmail?: string = null
  kundeTelefon?: string = null

  nachnameRules: any[] = [(v: any) => !!v || "Bitte Nachname angeben"]

  vornameRules: any[] = [(v: any) => !!v || "Bitte Vorname angeben"]

  emailRules: any[] = [
    (v: any) => !!v || "Bitte E-Mail angeben",
    (v: string) => /.+@.+\..+/.test(v) || "Bitte gültige E-Mail angeben",
  ]

  telefonRules: any[] = [(v) => !!v || "Bitte Telefon angeben"]

  bestaetigenLoadState: LoadState = LoadState.Idle

  init() {
    this.mainLogic.reservierungPendingListeners.push(() => {
      this.kundeVorname = this.mainLogic.reservierungPending.kundeVorname
      this.kundeNachname = this.mainLogic.reservierungPending.kundeNachname
      this.kundeTelefon = this.mainLogic.reservierungPending.kundeTelefon
      this.kundeEmail = this.mainLogic.reservierungPending.kundeEmail
    })

    this.kundeVorname = this.mainLogic.reservierungPending.kundeVorname
    this.kundeNachname = this.mainLogic.reservierungPending.kundeNachname
    this.kundeTelefon = this.mainLogic.reservierungPending.kundeTelefon
    this.kundeEmail = this.mainLogic.reservierungPending.kundeEmail
  }

  weiter() {
    this.bestaetigenLoadState = LoadState.Loading

    var request = new RPKundendatenRequest()
    request.id = vuexStore.state.user.identifier
    request.kundeNachname = this.kundeNachname
    request.kundeVorname = this.kundeVorname
    request.kundeTelefon = this.kundeTelefon
    request.kundeEmail = this.kundeEmail

    Poster.postUser<RemoteResult<any>>(
      RestPaths.reservierungenPendingKundendaten,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.bestaetigenLoadState = LoadState.Completed

          this.mainLogic.reservierungPending.kundeNachname = this.kundeNachname
          this.mainLogic.reservierungPending.kundeVorname = this.kundeVorname
          this.mainLogic.reservierungPending.kundeTelefon = this.kundeTelefon
          this.mainLogic.reservierungPending.kundeEmail = this.kundeEmail

          router.push({ name: RouteNames.NEU.BESTAETIGEN_RESERVIERUNG })
        } else {
          this.bestaetigenLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.bestaetigenLoadState = LoadState.Error
      })
  }

  produkteVorbestellen() {
    router.push({
      name: RouteNames.NEU.RESERVIETUNG_VORBESTELLUNG.PRODUKTE,
    })
  }
}
